import LinearProgress from '@mui/material/LinearProgress'
import {memo} from 'react'

export const DashboardProgress = memo(function DashboardProgress() {
  return <LinearProgress sx={{
    position: 'absolute',
    width: '100%',
  }}/>
})
